const BASE = 26;
const FIRST_CHAR_CODE = "a".charCodeAt(0);
export const MAX_COLUMNS = BASE * BASE; // 676

// Returns smallest fixed char-width that can address `columnCount` columns (0 if too many).
export function widthFor(columnCount: number): 1 | 2 | 0 {
    if (columnCount <= BASE) {
        return 1;
    }
    if (columnCount <= MAX_COLUMNS) {
        return 2;
    }
    return 0;
}

/**
 * Encodes a 0-based index into the given fixed width using lowercase letters
 * only. `width=1` for tables up to 26 columns, `width=2` for up to 676.
 */
export function encodeIndex(index: number, width: 1 | 2): string {
    if (width === 1) {
        return String.fromCharCode(FIRST_CHAR_CODE + index);
    }
    const high = Math.floor(index / BASE);
    const low = index % BASE;
    return (
        String.fromCharCode(FIRST_CHAR_CODE + high) +
        String.fromCharCode(FIRST_CHAR_CODE + low)
    );
}

/**
 * Decodes a fixed-width lowercase-letter chunk into the 0-based index.
 * Returns `null` if any character is outside `a-z`.
 */
export function decodeIndex(chunk: string): number | null {
    let value = 0;
    for (const char of chunk) {
        const digit = char.charCodeAt(0) - FIRST_CHAR_CODE;
        if (digit < 0 || digit >= BASE) {
            return null;
        }
        value = value * BASE + digit;
    }
    return value;
}
